import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
const faqItems = [{
  qKey: 'faq.q1',
  aKey: 'faq.a1'
}, {
  qKey: 'faq.q2',
  aKey: 'faq.a2'
}, {
  qKey: 'faq.q3',
  aKey: 'faq.a3'
}, {
  qKey: 'faq.q4',
  aKey: 'faq.a4'
}, {
  qKey: 'faq.q5',
  aKey: 'faq.a5'
}];
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };
  return <section id="faq" className="w-full bg-graphite py-20 sm:py-28" data-id="element-176">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-177">
        <ScrollFadeIn data-id="element-178">
          <div className="mb-4" data-id="element-179">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-180">
              {t('faq.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-12" data-id="element-181">
            {t('faq.heading')}
          </h2>
        </ScrollFadeIn>

        <div className="space-y-2" data-id="element-182">
          {faqItems.map((item, i) => {
          const isOpen = openIndex === i;
          return <ScrollFadeIn key={item.qKey} delay={i * 40} data-id="element-183">
                <div className="border border-slate-700/50 rounded bg-navy/50 overflow-hidden" data-id="element-184">
                  <button onClick={() => toggle(i)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left" aria-expanded={isOpen} data-id="element-185">
                    <span className="text-sm font-semibold text-white" data-id="element-186">
                      {t(item.qKey)}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-slate-500 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-187" />
                  </button>
                  <div className="overflow-hidden transition-all duration-300" style={{
                maxHeight: isOpen ? '300px' : '0',
                opacity: isOpen ? 1 : 0
              }} data-id="element-188">
                    <div className="px-5 pb-4" data-id="element-189">
                      <p className="text-sm text-slate-400 leading-relaxed" data-id="element-190">
                        {t(item.aKey)}
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollFadeIn>;
        })}
        </div>
      </div>
    </section>;
}